import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabase";
import { Helmet } from 'react-helmet-async';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Button } from "../../components/ui/Button";
import Input from "../../components/ui/Input";// ✅ named import

export default function AdminLogin() {
  const [email, setEmail] = useState("rathorprince938@gmail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    setLoading(false);

    if (error) {
      setError(error.message);
      return;
    }

    if (!data.user) {
      setError("Login failed. No user returned.");
      return;
    }

    // 👇 Optional: only allow this specific admin email
    if (data.user.email !== "rathorprince938@gmail.com") {
      setError("You are not allowed to access admin.");
      await supabase.auth.signOut();
      return;
    }

    navigate("/admin");
  };

  return (
    <>
     <Helmet>
    <meta name="robots" content="noindex, nofollow" />
  </Helmet>
    
      <Header />     
      <main className="min-h-screen flex items-center justify-center px-4">
        <div className="w-full max-w-md bg-card border rounded-2xl shadow p-6 space-y-4">
          <h1 className="text-2xl font-bold text-center">Admin Login</h1>
          <p className="text-sm text-muted-foreground text-center">
            Only for Make Mind Automations admin.
          </p>

          {error && (
            <div className="text-sm text-error bg-error/10 border border-error/20 rounded-md px-3 py-2">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium">Email</label>
              <Input
                type="email"
                name="email"
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setEmail(e.target.value)
                }
                className="mt-1"
                autoComplete="email"
              />
            </div>

            <div>
              <label className="text-sm font-medium">Password</label>
              <Input
                type="password"
                name="password"
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setPassword(e.target.value)
                }
                className="mt-1"
                autoComplete="current-password"
              />
            </div>

            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </Button>
          </form>
        </div>
      </main>
      <Footer />
    </>
  );
}
